var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-iframe"},[_c('iframe',{staticClass:"iframe-content",attrs:{"src":_vm.linkUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }